import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEye, FiLifeBuoy, FiRefreshCcw } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchData, fetchFormData, formatDateOnly } from "../../utils/options";

import ShowRenewalStatus from "../../utils/ShowRenewalStatus";

import { TbLibrary } from "react-icons/tb";

const StudentRenewal = ({ students }) => {
  const [saveData, setSaveData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [status, setStatus] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);
  useEffect(() => {
    setSaveData(students || []);
  }, [students]);


   const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };
  const columns = [
    {
      id: "actions",
      header: () => "Actions",
      cell: ({ row }) => {
        const id = row.original.id;
       
        const student_id=row.original.student_id
        return (
          <div className="d-flex gap-2">
            <span
              className="cursor-pointer"
              title="Update Status"
              onClick={() => {
                const rowData = row.original;

                setSelectedId(rowData.student_id);
                setStatus(Number(rowData["payout status"]));
                setSelectedStudent(rowData);
                setShowPopup(true);
              }}
            >
              <FiRefreshCcw size={16} />
            </span>

            <span
              className="cursor-pointer"
              onClick={() => navigate(`/student/renewalview/${student_id}`)}
              title="Content View"
            >
              <FiEye size={16} />
            </span>
             <span
              className="cursor-pointer"
              onClick={() => navigate(`/student/library/${student_id}`)}
              title="Library"
            >
              <TbLibrary size={16} />
            </span>
          </div>
        );
      },
      meta: {
        headerClassName: "width-30",
        exportable: false,
      },
    },
     
    {
      accessorKey: "payout status",
      header: () => "Subscripton status",
      cell: (info) => {
        const row = info.row.original;
        const status = Number(row["payout status"]);

        const statusInfo = {
          0:{ text: "Pending", bg: "rgb(246, 244, 240)", color: "#c87b0f" },
          // 1:{ text: "Admin Approval Required", bg: "#f2ece6ff", color: "#ffa21d" },
          1: { text: "Approved", bg: "#cfe1f4ff", color: "rgb(14, 96, 110)" },
          // 3: { text: "Rejected", bg: "#ebd7dcff", color: "#dc3545" },
          // 4:{text:"Expired",bg:"#f6dedeff",color:"#000" }
        };
        const st = statusInfo[status] || {
          text: "Unknown",
          bg: "#e2e3e5",
          color: "#6c757d",
        };
        return (
          <span
            style={{
              display: "inline-block",
              padding: "4px 8px",
              borderRadius: "4px",
              fontWeight: "bold",
              backgroundColor: st.bg,
              color: st.color,
            }}
          >
            {st.text}
          </span>
        );
      },
      defaultIsVisible: true,
    },
      {
      accessorKey: "name",
      header: () => "Student Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    
    {
      accessorKey: "phone",
      header: () => "phone",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "email",
      header: () => "email",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
   
    {
      accessorKey: "package_name",
      header: () => "package name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
      {
      accessorKey: "activate_date",
      header: () => "Subs. start date",
      cell: (info) => formatDate(info.getValue()),
      defaultIsVisible: true,
    },
   {
      accessorKey: "subscription_end_date",
      header: () => "subs. end date",
      cell: (info) => formatDate(info.getValue()),
      defaultIsVisible: true,
    },


    {
      accessorKey: "created_at",
      header: () => "created at",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },
  ];

  return (
    <>
      <Table data={saveData} columns={columns} />

      {selectedId && selectedStudent && (
        <ShowRenewalStatus
          show={showPopup}
          onClose={() => setShowPopup(false)}
          selectedId={selectedId}
          student={selectedStudent}
          currentStatus={status}
          onStatusChange={(id, newStatus) => {
            const fixedId = Number(id);
            const fixedStatus = Number(newStatus);

            setSaveData((prev) =>
              prev.map((item) =>
                Number(item.id) === fixedId
                  ? { ...item, subscription_status: fixedStatus }
                  : item
              )
            );

            setStatus(fixedStatus);
          }}
        />
      )}
    </>
  );
};

export default StudentRenewal;
